import * as React from 'react'
import type {SVGProps} from 'react'
const SvgSearchIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            d="M10.306 7.077q0-1.33-.943-2.273a3.16 3.16 0 0 0-2.286-.956 3.03 3.03 0 0 0-2.287.956q-.942.97-.943 2.273 0 1.305.943 2.286t2.287.943q1.342-.039 2.286-.943.943-.903.943-2.286M14 13.083q0 .375-.284.646a.92.92 0 0 1-.646.271.86.86 0 0 1-.646-.271l-2.467-2.467a4.96 4.96 0 0 1-2.88.891q-1.034 0-1.977-.4a4.95 4.95 0 0 1-1.614-1.085 5.4 5.4 0 0 1-1.085-1.615 4.6 4.6 0 0 1-.4-1.976 5.13 5.13 0 0 1 1.485-3.59A4.8 4.8 0 0 1 5.1 2.402a5.5 5.5 0 0 1 1.977-.4 4.36 4.36 0 0 1 1.976.4q.917.426 1.614 1.085.698.658 1.085 1.627.388.969.4 1.963 0 1.59-.89 2.88l2.467 2.467a.9.9 0 0 1 .271.659"
        />
    </svg>
)
export default SvgSearchIcon
